/**
 * Klab Organization API
 *
 * Contact: josealejandro2901@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DepartmentUpdateItem { 
    /**
     * ID of the existing department. Optional. If null, a new department is created.
     */
    departmentId?: number;
    /**
     * Name of the department.
     */
    name: string;
    /**
     * Actions related to the department
     */
    action?: DepartmentUpdateItem.ActionEnum;
}
export namespace DepartmentUpdateItem {
    export const ActionEnum = {
        Add: 'ADD',
        Delete: 'DELETE'
    } as const;
    export type ActionEnum = typeof ActionEnum[keyof typeof ActionEnum];
}


